import { create } from "zustand";

export const useFuelRequestsStore = create((set, get) => ({
  fuelRequestsData: [],
  selectedFuelRequestIds: [],
  fuelRequestsFilters: {
    search: "",
    pagination: {
      page: 1,
      pageSize: 10,
    },
    sort: { key: "name", direction: "ASC" },
  },
  fuelRequestsCount: 0,
  isInitialized: false,

  fuelHistoryRequestsFilters: {
    search: "",
    pagination: {
      page: 1,
      pageSize: 10,
    },
    sort: { key: "name", direction: "ASC" },
  },

  setSelectedFuelRequestIds: (ids) => set({ selectedFuelRequestIds: ids }),
  clearSelectedFuelRequestIds: () => set({ selectedFuelRequestIds: [] }),
  setFuelRequestsData: (newData) => {
    const state = get();
    const prevData = state.fuelRequestsData;
    const isInitialized = state.isInitialized;

    if (!isInitialized) {
      set({
        fuelRequestsData: newData,
        isInitialized: true,
      });
      return;
    }

    const prevIds = new Set(prevData.map((item) => item.id));
    const newItems = newData?.filter((item) => !prevIds.has(item.id));
    const newCountableItems = newItems?.filter((item) => item.action === "NEW");
    const newCount = state.fuelRequestsCount + newCountableItems.length;

    set({
      fuelRequestsData: newData,
      fuelRequestsCount: newCount,
    });
  },
  setFuelRequestsFilters: (filters) =>
    set((state) => ({
      fuelRequestsFilters: {
        ...state.fuelRequestsFilters,
        ...filters,
        pagination: {
          ...state.fuelRequestsFilters.pagination,
          ...filters.pagination,
        },
        sort: {
          ...state.fuelRequestsFilters.sort,
          ...filters.sort,
        },
      },
    })),
  setFuelHistoryRequestsFilters: (filters) =>
    set((state) => ({
      fuelHistoryRequestsFilters: {
        ...state.fuelHistoryRequestsFilters,
        ...filters,
        pagination: {
          ...state.fuelHistoryRequestsFilters.pagination,
          ...filters.pagination,
        },
        sort: {
          ...state.fuelHistoryRequestsFilters.sort,
          ...filters.sort,
        },
      },
    })),
  resetFuelRequestsCount: () => set({ fuelRequestsCount: 0 }),
}));
